import { Link, type LinkProps } from '@tanstack/react-router';
import clsx from 'clsx';
import { type ComponentProps } from 'react';

import { Button } from '@furality/furality-purpose';

const LinkButton = ({
  className,
  disabled,
  ...props
}: LinkProps & Omit<ComponentProps<typeof Button>, 'href' | 'as'>) => (
  <Button
    as={Link}
    {...props}
    disabled={disabled}
    className={clsx(className, disabled && 'disabled')}
  />
);

export default LinkButton;
